import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  constructor() { }

  handleApiError(err){
    if(err.error && err.error.Message){
      // if there is validation or applcation errors and unhandle exceptions in the api
      return err.error.Message
    }
    
    
    let errorMessage = "";

    switch(err.status){
      case 0:
        errorMessage = "There is no network connection";
        break;
      case 401:
        errorMessage = "You entered a wrong username or password";
        break;
      default:
        errorMessage =  "Unknown error";
        break;
    }

    return errorMessage;
  }
}
